import PortalIdParser from 'PortalIdParser';

import { NAMESPACE_PREFIX } from '../constants';
import { SuperstoreOptions } from '../Superstore';

export default (opts: SuperstoreOptions): string => {
  let storeName = opts.namespace;

  if (opts && opts.namespace) {
    storeName = `${NAMESPACE_PREFIX}.${opts.namespace}`;
  }

  if (!opts.global) {
    let partitionFn: Function;

    if (opts.partition && typeof opts.partition === 'function') {
      partitionFn = opts.partition;
    } else {
      partitionFn = () => PortalIdParser.get();
    }

    let partitionVal = partitionFn!();

    if (partitionVal) {
      partitionVal = `.${partitionVal}`;
    } else {
      partitionVal = '';
    }

    storeName = `${storeName}${partitionVal}`;
  }

  return storeName;
};
